<header [ngClass]="{'add-height': showCounter }">
    <div class="container-fluid"> 
        <div class="heading">          
            <h1>Hvis Anne kan <br class="d-block d-sm-none">vinde, <br class="d-none d-sm-block">så kan du <br class="d-block d-sm-none">også!</h1>
        </div>
        <!--URGENCY COUNTEREN-->
        <div *ngIf="showCounter" class="urgency mx-auto text-kl-white text-center">
            <h5>Salget til næste trækning lukker om</h5>
            <app-countdown-v2 [date]="countdownDate"></app-countdown-v2>
        </div> 
        <div class="winner">
            <img class="img-fluid" src="../../../assets/images/winners/Anne-webOptim-512x512px.png" alt="Milllionpakken lodpakke">
        </div>
        <div class="image-text">
            <p>Anne <br>Vinder af</p>
            <h6>132.842,50 kr.</h6>
        </div> 
        <div class="cta">
            <button (click)="showPage()" class="cta cta--primary" [ngClass]="{'cta-text-change': isSafariBrowser }">Spil med</button>
        </div>  
    </div>  
</header>
